// visitAppointment.js — settle the appointment behind a payment.
//
// WHY (incident 2026-07-22, Nadia Cooblall): when staff took payment that
// wasn't opened from a specific appointment, the POS/terminal blindly INSERTed
// a brand-new appointment with **no provider** (pid/prov null). That ghost
// visit doesn't belong to anyone's column, so the client silently dropped off
// her provider's schedule (Sarah's), and the real appointment was left behind
// as a duplicate. Same pattern produced appt 5002045 (Alexandria) and 5002061.
//
// Correct behaviour: if the client already has a (non-cancelled) appointment
// TODAY, that IS the visit being paid for — mark it paid/completed and keep it
// on the provider's schedule. Only create a new row for a genuine walk-in with
// nothing booked.
import { supabase } from "./supabase";

export async function settleVisitAppointment({ clientId, clientName, treatmentName, total, notes }) {
  if (!clientId) return null;
  const today = new Date();
  const dateStr = today.toLocaleDateString("en-CA"); // local YYYY-MM-DD

  // 1) Reuse the client's existing appointment for today (keeps the provider).
  try {
    const { data: existing } = await supabase.from("appointments")
      .select("id,pid,prov")
      .eq("cid", clientId)
      .eq("date", dateStr)
      .neq("status", "cancelled")
      .order("time", { ascending: true })
      .limit(1);
    if (existing && existing.length) {
      await supabase.from("appointments").update({
        paid: true, status: "completed", checkin: "checked-out",
      }).eq("id", existing[0].id);
      return existing[0].id;
    }
  } catch (e) { console.warn("[visit] lookup failed:", e); }

  // 2) Genuine walk-in — nothing was booked today, so record the visit.
  try {
    const { data: created } = await supabase.from("appointments").insert({
      cid: clientId,
      cn: clientName || "",
      treat: treatmentName,
      price: total,
      date: dateStr,
      time: today.toTimeString().slice(0, 5),
      dur: 60,
      status: "completed",
      checkin: "checked-out",
      paid: true,
      tip: 0,
      dep: 0,
      loc: "Nova Med Spa",
      notes: notes || "",
    }).select("id").single();
    return created?.id || null;
  } catch (e) {
    console.warn("[visit] create failed:", e);
    return null;
  }
}
